import { createFileRoute } from '@tanstack/react-router'
import Leaderboard from "@/views/mario/Leaderboard";

export const Route = createFileRoute(
  '/_authenticated/_staff/achievements/leaderboard',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <Leaderboard/>
}
